import { render, staticRenderFns } from "./indexIVA.vue?vue&type=template&id=57e6de49&"
import script from "./indexIVA.vue?vue&type=script&lang=js&"
export * from "./indexIVA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports